var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isForeman())?_c('div',{staticClass:"pay-type-display"},[(_vm.data.pay_type === 'Price')?_c('span',[_vm._v("\n    "+_vm._s(_vm.data.pay_type)+"\n  ")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.data.pay_type)+" ("+_vm._s(_vm._f("currency")(_vm.data.pay_amount))+")\n  ")])]):_c('div',[_vm._v("\n  "+_vm._s(_vm.data.pay_type)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }